<template lang="pug">
  span.notification-count(v-if="count > 0") {{ count }}
</template>

<script>
/**
 * Красный кружок с числом непрочитанных уведомлений. Один на всю систему:
 * плитки проектов, компаний, этапов, задач и заявок CRM показывают его
 * одинаково. При нуле не рендерится вовсе — условие в родителе не нужно.
 */
export default {
  name: 'NotificationCount',
  props: {
    count: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped lang="scss">
.notification-count {
  font-size: 12px;
  line-height: 15px;
  color: #FFFFFF;
  background: #F17275;
  min-width: 7px;
  border-radius: 12px;
  padding: 0 4px;
  text-align: center;
  display: inline-block;
}
</style>
